exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1XxqJIu7tpLd89IKPhmjtt{display:block;height:1px;position:relative}html[dir] ._1XxqJIu7tpLd89IKPhmjtt{background-color:\"[theme:neutralLight, default:#eaeaea]\"}", ""]);
// Exports
exports.locals = {
	"replyWithSeparator": "_1XxqJIu7tpLd89IKPhmjtt"
};